import { Translate } from "lib/i18n/client";

export type Money = {
  amount: number;
  currency: string;
};

export type MoneyV2 = {
  amount: string;
  currency: string;
};

export class HttpError extends Error {
  public readonly statusCode: number;
  public readonly errorCode?: string;
  public readonly errorMessage?: string;

  constructor(
    message: string,
    statusCode: number,
    errorCode?: string,
    errorMessage?: string,
  ) {
    super(`${message}. Status code: ${statusCode}; Error code: ${errorCode}`);
    this.statusCode = statusCode;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
  }
}

export const ErrorMap = {
  200: "errors:defaultError.ok",
  400: "errors:defaultError.bad_request",
  401: "errors:defaultError.unauthorized",
  403: "errors:defaultError.forbidden",
  404: "errors:defaultError.not_found",
  409: "errors:defaultError.conflict",
  429: "errors:defaultError.too_many_requests",
  499: "errors:defaultError.canceled",
  500: "errors:defaultError.server_error",
  501: "errors:defaultError.not_implemented",
  503: "errors:defaultError.service_unavailable",
  504: "errors:defaultError.gateway_timeout",
} as { [key: number]: string };

export interface ErrorDetail {
  "@type": string;
}

export const ErrorInfoType = "type.googleapis.com/google.rpc.ErrorInfo";

export interface ErrorInfo extends ErrorDetail {
  reason: string;
  metadata?: { [key: string]: string };
}

export class StatusHttpError extends Error {
  public readonly statusCode: number;
  public readonly errorCode: number;
  public readonly errorMessage: string;
  public readonly errorDetails: Array<ErrorDetail>;

  constructor(
    statusCode: number,
    errorCode: number,
    errorMessage: string,
    errorDetails?: Array<ErrorDetail>,
  ) {
    super(`HTTP Status code: ${statusCode}; Error code: ${errorCode}`);
    this.statusCode = statusCode;
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.errorDetails = errorDetails || [];
  }
}

export const errorTranslation = (
  t: Translate,
  statusErr: unknown,
  customErrorPrefix = "error.",
): string => {
  if (!(statusErr instanceof StatusHttpError)) {
    return t("errors:defaultError.unknown_error");
  }
  if (statusErr.errorDetails && statusErr.errorDetails.length > 0) {
    const details = statusErr.errorDetails[0];
    if (details["@type"] === ErrorInfoType) {
      // We could add more types here
      return t(
        `${customErrorPrefix}${(details as ErrorInfo).reason.toLowerCase()}`,
        {
          ...(details as ErrorInfo).metadata,
          defaultValue:
            ErrorMap[statusErr.errorCode] ||
            "errors:defaultError.unknown_error",
        },
      );
    }
  }
  return t(
    ErrorMap[statusErr.errorCode] || "errors:defaultError.unknown_error",
  );
};
